// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"63":"SuperAdminDashboard","175":"NoServer","704":"changePassword","939":"AppMain"}[chunkId] || chunkId) + "." + {"22":"3fe378a3","63":"ad2c0ab9","175":"6f033675","704":"de04c3e9","939":"bffdb9b5"}[chunkId] + ".chunk.css";
};